import React from 'react';
import { TAndroidWatchesImportantMessages } from 'types/index';
import { androidWatchesImportantMessagesTypes } from 'appConstants/index';
import FormSelect from 'components/Select/FormSelect';
import style from './ImportantMessagesSelect.module.scss';

interface IProps {
	setImportantMessages: (value: TAndroidWatchesImportantMessages[]) => void;
}

export const ImportantMessagesSelect: React.FC<IProps> = React.memo(({ setImportantMessages }) => {
	return (
		<FormSelect
			containerClassName={style.select}
			testId="ImportantMessagesSelect"
			name="importantMessages"
			label="importantMessagesLabel"
			options={androidWatchesImportantMessagesTypes}
			onChange={setImportantMessages}
			mode="multiple"
			showSearch={false}
		/>
	);
});
